import React, { Component } from "react";
import { Provider } from "react-redux";
import AppRouter from "./containers/AppRouter";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "./configureStore";
// We can add initial state information as a parameter here. removed it for now because
// we do that in our reducers / actions already.
const store = configureStore();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppRouter />
        </ConnectedRouter>
      </Provider>
      );
  }
}

export default App;
